import {useQuery} from 'react-query';
import axios from 'axios';
import Config from '../Config';
import {useSelector} from 'react-redux';    

const useOrderDetails = (orderId) => {
    const user = useSelector((state) => state.UserReducer.user);
    return useQuery(
        ['order', user?.token, orderId],
        async () => {
            const { data } = await axios.get(`${Config.apiUrl}/orders/${orderId}`, {
                headers: { Authorization: `Bearer ${user.token}` },
            });
            return data.data.order;
        },
        {
            enabled: !!user?.token && !!orderId, // only run if we have a token and orderId
            staleTime: 1000 * 60 * 5, // 5 minutes
            retry: 1, // retry once on failure
        }
    );
}

export default useOrderDetails;